import React from 'react'
import './CSS/ContactUs.css'

const ContactUs = () => {
  return (
    <div className='ContactUs'>
    <div className="ContactUs-container">
      <h1>Contact Us</h1>
      <h3>Last updated on 18-07-2024 13:28:24</h3>
      <span>You may contact us using the information below:</span>
      <div className="important">
      <p><span>Merchant Legal entity name:</span> Attire Avenue</p>
      <p><span>Registered Address:</span> Industrial Area, Bhiwani, Haryana, PIN: 127021</p>
      <p><span>Operational Address:</span> Industrial Area, Bhiwani, Haryana, PIN: 127021</p>
      <p><span>Telephone No:</span> 9518165728</p>
      <p><span>E-Mail ID:</span> attireavenueteam@gmail.com</p>
      </div>
    </div>
    </div>
  )
}

export default ContactUs
